import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, VerificationCardButtonTypeToken, } from '@voltmoney/schema';
import React, { memo } from 'react';
import { Text, View } from 'react-native';
import Icon from '../icon/Icon';
import Space from '../space/Space';
import Typography from '../typography/Typography';
import { Component as Stack } from '../stack';
import Button from '../button/Button';
import ThemeProvider from '@voltmoney/theme';
/**
 * Raw Component with Derived props + Theme
 */
const VerificationDefaultBase = ({ id, label, message, buttonType = VerificationCardButtonTypeToken.FULL, triggerAction, buttonText, icon, iconName = IconTokens.Alert, action, }) => {
    const theme = ThemeProvider.getTheme();
    return (React.createElement(View, { style: [
            {
                justifyContent: 'center',
                backgroundColor: theme.colors[ColorTokens.White],
                borderRadius: 12,
                padding: 16,
            },
        ] },
        React.createElement(Stack, { justifyContent: StackJustifyContent.center, alignItems: StackAlignItems.center },
            React.createElement(Space, { size: SizeTypeTokens.XXXXL }),
            React.createElement(Icon, { name: iconName || icon.name, size: IconSizeTokens.Size56 }),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(Text, { style: {
                    textAlignVertical: 'center',
                    textAlign: 'center',
                } },
                React.createElement(Typography, { label: label, color: ColorTokens.Grey_Night, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.XL, numberOfLines: 2 })),
            React.createElement(Space, { size: SizeTypeTokens.SM }),
            message ? (React.createElement(View, { style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                } },
                React.createElement(Text, { style: {
                        textAlignVertical: 'center',
                        textAlign: 'center',
                    } },
                    React.createElement(Typography, { label: message, color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, numberOfLines: 2 })))) : (React.createElement(React.Fragment, null)),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            buttonText ? (React.createElement(View, { testID: label },
                React.createElement(Button, { id: id, label: buttonText, action: action, triggerAction: triggerAction, type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL }))) : (React.createElement(React.Fragment, null)))));
};
export default memo(VerificationDefaultBase);
export { VerificationDefaultBase };
